import { apiRequest } from '@/utils/api-request';

export interface OrgAdminCatalogItem {
  node_id: string;
  display_name: string;
  description: string;
  node_type: string;
  category: string;
  icon: string;
  enabled_by_org: boolean;
}

interface OrgAdminCatalogResponse {
  success: boolean;
  total_nodes: number;
  catalog: OrgAdminCatalogItem[];
}

export const getOrgAdminCatalog = async (
  orgId: string,
): Promise<OrgAdminCatalogItem[]> => {
  const response = await apiRequest<OrgAdminCatalogResponse>({
    url: `/nodes/${orgId}/admin/catalog`,
    method: 'GET',
    target: 'workflow',
  });

  if (response?.detail) {
    throw new Error(response.detail);
  }

  return response?.data?.catalog || [];
};
